export const setValueInHours = (value?: number | null) => {
  if (value) {
    return (value / 60).toFixed(2);
  } else return 0;
};
